<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon color="hrissecondary">
              mdi-backup-restore
            </v-icon>
          </v-btn>
        </template>
        <span>Revert current status to Pending</span>
      </v-tooltip>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Revert selected cycle"
      text="Revert Computed to Pending"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              Are you sure to revert <span class="font-weight-medium">{{ payrollCycleTransaction.payroll_cycle.name }}</span> from <span class="text-primary">COMPUTED</span> to <span class="text-warning">PENDING</span>?
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"           
          @click="submitForm"
        >
          Revert
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      payrollCycleTransaction: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
      }
    },

    methods: {
      submitForm () {
        this.progressing = true

        this.$api.payrollCycleTransactions().update(this.payrollCycleTransaction.id, this.prepareFormData())
          .then(res => {
            this.$snack({ message: res.data.status })
            this.$emit('reverted')
            this.$emit('payrollReverted')
            this.progressing = false

            this.dialog = false
          }).catch(error => {
            this.progressing = false
            this.$snack({ 
              color: 'error',
              message: error.response.data.message, 
            })
          })
      },

      prepareFormData () {
        return {
          status: 'PENDING',
        }
      },
    },
  }
</script>
